<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="page_1">THE EVOLUTION OF VERTEBRATE DESIGN</p>
<p class="imagef"><img alt="image" src="html/images/f0001-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226220635_07_haf.vue?368ba83c